import { ModelFactory } from "../../ModelFactory";

export class TenantSettings {
  constructor(
    public readonly id: string,
    public readonly brandTitle: string,
    public readonly brandSubTitle: string,
    public readonly brandImageURL: string,
    public readonly colorPalette: string,
    public readonly previewDomainUuid: string,
    public readonly customersAllowedToOrderDomains: boolean,
    public readonly created: Date,
    public readonly updated: Date,
  ) {
  }
}

class TenantSettingsFactory extends ModelFactory<TenantSettings> {
  protected fromJson(json: any): TenantSettings {
    return new TenantSettings(
      json['id'],
      json['config']['brand_title'],
      json['config']['brand_sub_title'],
      json['config']['brand_image_url'],
      json['config']['color_palette'],
      json['config']['preview_domain_id'],
      json['config']['customers_allowed_to_order_domains'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    );
  }
}
export const tenantSettingsFactory = new TenantSettingsFactory();
